import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorker from "@/pwa/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Phase 4 — PWA: register service worker on production web builds only.
// The helper internally no-ops on non-web Capacitor bundles and in dev mode.
serviceWorker.register();
